export const blinkingNotifyTab = (message: string) => {
  document.title = message
  setTimeout(() => {
    document.title = 'Loon Health - Birth Control Delivered For $0'
  }, 1000)
}
